'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = '5';
var width = 320;
var height = 512;
var aliases = [];
var unicode = '35';
var svgPathData = 'M0 56C0 42.7 10.7 32 24 32l240 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-216 0 0 128 136 0c75.1 0 136 60.9 136 136S259.1 480 184 480L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l160 0c48.6 0 88-39.4 88-88s-39.4-88-88-88L24 256c-13.3 0-24-10.7-24-24L0 56z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.fa5 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;